import { IconButton } from '@festina-life/ui/actions'
import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'

type Props = { isOpen: boolean; onClick: () => void }

export const CollapsibleHandleButton = ({ isOpen, onClick }: Props) => (
  <IconButton
    iconName={isOpen ? 'ChevronLeft' : 'ChevronRight'}
    iconSize="md"
    className={cx(
      'absolute! right-0 top-1 z-10 translate-x-full p-2! rounded-l-none! rounded-r-md! size-7',
      paperStyles({ borders: ['all'] }),
    )}
    onClick={onClick}
  />
)
